import { Icon, notification } from 'antd';
import React from 'react'
/**
*Mostrar notificaciones de advertencia o estatus ok al usuario
* 
*@param: mensaje: Mensaje que se mostrará en el cuerpo de la notificación 
*@param: titulo: Mensaje que se mostrará en el título de la notificación 
*@param: boolean: Si se recibe true, se mostrará el mensaje de estatus ok. 
* Si se resibe false, se mostrará mensaje de advertencia. 
*@return: nada
*/
export const openNotification = (mensaje, titulo, boolean = true) => {
    notification.config({
        placement: 'bottomRight',
        duration: 7,
    })
    if (boolean) {
        notification.open({
            message: titulo,
            description: mensaje,
            style: {
                whiteSpace: 'pre-wrap',
                wordWrap: 'break-word'
            },
            icon: <Icon type="check-circle" style={{ color: '#108ee9' }} />,
        });
    } else {
        notification.warning({
            message: titulo ?? 'Error',
            description: mensaje ?? 'Ha ocurrido un error inesperado, favor de reportarlo.',
            style: {
                whiteSpace: 'pre-wrap',
                wordWrap: 'break-word'
            },
            icon: <Icon type="exclamation-circle" style={{ color: 'rgb(253, 135, 0)' }} />,
            duration: 60
        });
    }
}